import { render, staticRenderFns } from "./SkillsComponent.vue?vue&type=template&id=5d130f85"
import script from "./SkillsComponent.vue?vue&type=script&lang=ts"
export * from "./SkillsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports